export default __webpack_public_path__ + "static/media/verifyreport.4f54a973.svg";